import React from "react";
import styles from "./ProductItem.module.scss";
import classnames from "classnames";
import { getSelectedExchangeVariant, isServiceFlowActive } from "~/cores/appCore";
import CloseIcon from "../../icons/CloseIcon";
import { formatCurrency } from "../../utils";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";
import { getProductImageSrc } from "~/cores/productCore";
import { getSelectedReturnMethod, isComplaintSelected, isExchangeSelected, isResaleSelected } from "~/cores/selectedProductValuesCore";
import { getBrandProductImageObjectFit } from "~/cores/brandDataCore";

export default function ProductItem(props) {
    const {
        appProps,
        product,
        smallImage = false,
        contentOpacity,
        exchangeTitleLineThrough = true,
        subTitle,
        imageOverlay,
        children,
        getLocaleText,
        topRightText = null,
        selectedProductValues,
        onClose,
        loginServiceData = appProps?.loginServiceData,
        productsExchangeServiceData,
        language,
    } = props;
    let exchangeItem = null;

    const exchangeToProductId = isExchangeSelected(selectedProductValues) && selectedProductValues?.exchangeToProductId;
    let exchangeToProduct =
        selectedProductValues?.swapProduct ||
        (exchangeToProductId && exchangeToProductId !== product?.actualProductId && productsExchangeServiceData?.[product?.sessionItemId]?.data?.products?.find((p) => p.id === exchangeToProductId));
    if (exchangeToProduct?.actualProductId === product?.actualProductId) {
        exchangeToProduct = null;
    }
    const actualProduct = exchangeToProduct || product;

    const propertyTranslations = actualProduct?.propertyTranslations;

    function translateProperty(p) {
        return propertyTranslations?.[p?.type]?.[p?.value]?.[language] || p?.value;
    }

    if (isExchangeSelected(selectedProductValues)) {
        exchangeItem = getSelectedExchangeVariant(props, product?.sessionItemId, selectedProductValues?.exchangeToProductId, selectedProductValues.exchangeAlternativeId);
    }
    let combinedProperties = actualProduct?.properties?.map(({ type, value }) => ({ type, value, oldValue: value }));
    exchangeItem?.properties?.forEach((p) => {
        let existingProperty = combinedProperties?.find((property) => property.type === p.type);
        if (existingProperty?.value && existingProperty?.value !== p.value) {
            existingProperty.value = p.value;
        }
    });

    let productImage = getProductImageSrc(exchangeItem) || getProductImageSrc(exchangeItem?.product) || getProductImageSrc(actualProduct) || getProductImageSrc(actualProduct?.product);

    if (selectedProductValues && exchangeToProductId) {
        combinedProperties = combinedProperties?.map((cp) => {
            const newValue = selectedProductValues?.exchangePropertyChoices?.[cp.type];
            if (newValue) {
                return { type: cp.type, value: newValue, oldValue: cp.value };
            }
            return cp;
        });
        // Object.keys(selectedProductValues?.exchangePropertyChoices).map(key => {
        //     const value = selectedProductValues?.exchangePropertyChoices[key];
        //     return {type: key, value: value, oldValue: value}
        // });
    }
    const filteredCombinedValues = combinedProperties?.filter(({ value, oldValue }) => value || oldValue);

    const currencyCode = loginServiceData?.data?.currencyCode;

    let moneyBackAmount;
    if (isExchangeSelected(selectedProductValues) && exchangeToProduct) {
        moneyBackAmount = product?.purchasePrice - exchangeToProduct?.purchasePrice;
    } else if (isResaleSelected(selectedProductValues)) {
        moneyBackAmount = selectedProductValues?.price;
    } else if (!isExchangeSelected(selectedProductValues) && selectedProductValues) {
        moneyBackAmount = product?.purchasePrice;
    }

    const moneyBackIsNegative = moneyBackAmount < 0;

    // const oldValues = isExchangeSelected(selectedProductValues) && !exchangeToProduct ["test"] : [];

    const isComplaintWithExchange = isComplaintSelected(selectedProductValues) && selectedProductValues?.exchangeAlternativeId;

    return (
        <ProductItemWrapperOnly {...props} selected={topRightText || onClose || selectedProductValues ? true : undefined}>
            {topRightText || selectedProductValues ? (
                <div className={classnames(styles["product-chip"], onClose && styles["product-chip-close"])}>
                    {/*<div className={classnames(styles["product-chip-top-left-thingy"], styles["thingy-brand"])}/>*/}
                    {/*<div className={classnames(styles["product-chip-top-left-thingy"], styles["thingy-white"])}/>*/}
                    {/*<div className={classnames(styles["product-chip-bottom-right-thingy"], styles["thingy-brand"])}/>*/}
                    {/*<div className={classnames(styles["product-chip-bottom-right-thingy"], styles["thingy-white"])}/>*/}

                    {topRightText || getLocaleText(getSelectedReturnMethod(selectedProductValues))}
                    {onClose && (
                        <div
                            className={styles["product-close"]}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClose();
                            }}
                        >
                            <CloseIcon className={styles["close-icon"]} />
                        </div>
                    )}
                </div>
            ) : onClose ? (
                <div className={classnames(styles["product-chip-on-close-only"])}>
                    <div
                        className={styles["product-close"]}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }}
                    >
                        <CloseIcon className={styles["close-icon"]} />
                    </div>
                </div>
            ) : null}
            <div className={styles["image-container"]} style={{ opacity: contentOpacity && 0.5 }}>
                <div className={classnames(styles["image-inner-container"], smallImage && styles["image-inner-container-small"])}>
                    {productImage ? <CustomImageNew className={styles["image"]} fill style={{ objectFit: getBrandProductImageObjectFit(appProps) }} src={productImage} alt="Product item" /> : null}
                    {imageOverlay && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {imageOverlay}
                        </div>
                    )}
                </div>
            </div>
            {/*{selectedProductValues && !onClose && <div className={styles["checkbox"]}><CheckboxIcon width={"24px"} /></div>}*/}
            <div className={styles["content-container"]}>
                <div className={styles["name-chip-container"]}>
                    <h3
                        style={{
                            marginTop: "7px",
                            marginBottom: "4px",
                            wordBreak: "break-word",
                            opacity: contentOpacity && 0.5,
                        }}
                        className={classnames(styles["product-name"])}
                    >
                        {exchangeToProduct && exchangeTitleLineThrough ? (
                            <div>
                                <div
                                    style={{
                                        fontWeight: "normal",
                                        fontSize: "13px",
                                    }}
                                    className={styles["product-variant-value-replaced"]}
                                >
                                    {product?.productName}
                                </div>
                                {actualProduct?.productName}
                            </div>
                        ) : (
                            actualProduct?.productName
                        )}
                    </h3>
                    {/*<div className={styles["product-chip-wrapper"]}>*/}
                    {subTitle && <div className={styles["subtitle"]}>{subTitle}</div>}
                    <div className={styles["product-variants"]}>
                        {filteredCombinedValues?.map(({ type, value, oldValue }, index) => {
                            const actualOldValue = product?.properties?.find((p) => p.type === type)?.value;
                            return (
                                <React.Fragment key={type}>
                                    {/*<span*/}
                                    {/*    className={s tyles["product-variant-key"]}>{getLocaleText("variant." + type) || getLocaleText("variant.UNKNOWN")}</span>*/}
                                    {/*<span className={styles["product-variant-key"]}>-</span>*/}
                                    <div>
                                        {isExchangeSelected(selectedProductValues) && !exchangeToProduct && actualOldValue !== value && (
                                            <span
                                                style={{
                                                    marginRight: "10px",
                                                }}
                                                className={classnames(styles["product-variant-value"])}
                                            >
                                                <span className={styles["product-variant-value-replaced"]}>{actualOldValue}</span>,
                                            </span>
                                        )}
                                        <span
                                            className={classnames(
                                                styles["product-variant-value"],
                                                // isExchange && styles["product-variant-value-exchange"]
                                            )}
                                        >
                                            {translateProperty({
                                                type,
                                                value: value || oldValue,
                                            })}
                                            {filteredCombinedValues?.length - 1 !== index && ","}
                                        </span>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                    <div style={{ opacity: contentOpacity && 0.5 }} className={styles["products-cost-wrapper"]}>
                        {currencyCode && actualProduct?.purchasePrice && !isServiceFlowActive(appProps) ? (
                            moneyBackAmount ? (
                                <div className={classnames(styles["money-back"])}>
                                    {isComplaintWithExchange ? (
                                        <div>{getLocaleText("free-exchange")}</div>
                                    ) : moneyBackIsNegative ? (
                                        <div className={styles["money-back-negative"]}>
                                            {getLocaleText("money-back-negative")}:{" "}
                                            <span>
                                                {formatCurrency({
                                                    amount: -moneyBackAmount,
                                                    currency: currencyCode,
                                                })}
                                            </span>
                                        </div>
                                    ) : (
                                        <div>
                                            {getLocaleText("money-back")}:{" "}
                                            <span>
                                                {formatCurrency({
                                                    amount: moneyBackAmount,
                                                    currency: currencyCode,
                                                })}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className={classnames(styles["price"], styles["product-variant-key"])}>
                                    {formatCurrency({
                                        amount: actualProduct?.purchasePrice,
                                        currency: currencyCode,
                                    })}
                                </div>
                            )
                        ) : null}
                    </div>
                    {/*</div>*/}
                </div>
                {/*<div*/}
                {/*    style={{ opacity: contentOpacity && 0.5 }}*/}
                {/*    className={styles["products-cost-wrapper"]}*/}
                {/*>*/}
                {/*    {currencyCode && actualProduct?.purchasePrice ? (*/}
                {/*        moneyBackAmount ? (*/}
                {/*            <div className={styles["money-back"]}>*/}
                {/*                {isComplaintWithExchange ? (*/}
                {/*                    <div>{getLocaleText("free-exchange")}</div>*/}
                {/*                ) : (*/}
                {/*                    <>*/}
                {/*                        {getLocaleText("money-back")}:{" "}*/}
                {/*                        <b>*/}
                {/*                            {formatCurrency({*/}
                {/*                                amount: moneyBackAmount,*/}
                {/*                                currency: currencyCode,*/}
                {/*                            })}*/}
                {/*                        </b>*/}
                {/*                    </>*/}
                {/*                )}*/}
                {/*            </div>*/}
                {/*        ) : (*/}
                {/*            <div*/}
                {/*                className={classnames(*/}
                {/*                    styles["price"],*/}
                {/*                    styles["product-variant-key"],*/}
                {/*                )}*/}
                {/*            >*/}
                {/*                {formatCurrency({*/}
                {/*                    amount: actualProduct?.purchasePrice,*/}
                {/*                    currency: currencyCode,*/}
                {/*                })}*/}
                {/*            </div>*/}
                {/*        )*/}
                {/*    ) : null}*/}
                {/*</div>*/}
            </div>
            {children}
        </ProductItemWrapperOnly>
    );
}

export function ProductItemWrapperOnly(props) {
    const { children, onClick, className, dataTestId, tight, selectedProductValues, selected = !!selectedProductValues, style } = props;
    return (
        <div
            onClick={onClick}
            data-test-id={dataTestId}
            style={style}
            className={classnames(styles["product-item"], className, tight && styles["tight"], selected && styles["product-item-has-new-values"], onClick && styles["product-item-clickable"])}
        >
            {children}
        </div>
    );
}
